import { render } from "./AddVKDialog.vue?vue&type=template&id=817f1f72&scoped=true&ts=true"
import script from "./AddVKDialog.vue?vue&type=script&lang=ts"
export * from "./AddVKDialog.vue?vue&type=script&lang=ts"

import "./AddVKDialog.vue?vue&type=style&index=0&id=817f1f72&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-817f1f72"]])

export default __exports__